<template>
    <p class="toast" v-show="toast.show">
        {{toast.title}}
    </p>
</template>
<script>
export default {
    name:"toast",
    props:['msg'],
    data () {
      return{
        toast:{
           show:false,
           title:''
       }
      }  
       
    },
    created(){
     this.bus.$on('toast',(data)=>{
         this.toast=data;
     })
    },
    watch:{
          toast:function(){
              if (this.toast.show) {
                setTimeout(()=>{
                    this.toast.show=false;
                },1500)  
              }
          }
    },
    methods: {
        
    }
}
</script>
<style scoped>
    .toast{
        position: fixed;
        padding: .3rem;
        width: 45%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        font-size: .3rem;
        background: rgba(0,0,0,.5);
        left: 27.5%;
        top: 45%;
        color: #fff;
        border-radius: .1rem;
        z-index: 1000;
        word-wrap: break-word;
    }
     p{
            padding: .1rem .0.5rem;
            font-size: 0.24rem;
            background-color: rgba(0,0,0,0.8);
            border-radius: 4px;
        }
</style>
